import { render, staticRenderFns } from "./power-curve.vue?vue&type=template&id=30f6c3a6&scoped=true"
import script from "./power-curve.vue?vue&type=script&lang=js"
export * from "./power-curve.vue?vue&type=script&lang=js"
import style0 from "./power-curve.vue?vue&type=style&index=0&id=30f6c3a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f6c3a6",
  null
  
)

export default component.exports